/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function NoSuccessIcon({ className, size = 'small' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 .5a9.5 9.5 0 110 19 9.5 9.5 0 010-19zm-.003 1c-4.696 0-8.503 3.806-8.503 8.5s3.807 8.5 8.503 8.5S18.5 14.694 18.5 10s-3.807-8.5-8.503-8.5zm-3.18 5.318a.502.502 0 01.708 0L10 9.293l2.475-2.475a.5.5 0 01.707.707L10.707 10l2.475 2.475a.5.5 0 01-.707.707L10 10.707l-2.475 2.475a.5.5 0 01-.707-.707L9.293 10 6.818 7.525a.499.499 0 010-.707z" })));
}
//# sourceMappingURL=NoSuccessIcon.js.map